

















import FormCommerceKind from '@/components/CommerceKind/form.vue';
import commerceKind from '@/store/types/commerceKind';
import { newCommerceKindType } from '@/store/interfaces/BlobImage';
import { mapActions } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'NewCommerceKind',
  components: {
    FormCommerceKind,
  },
  props: {
    newCommerce: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      clean: false,
    };
  },
  computed: {
    syncedNewCommerceKind: {
      get(): boolean {
        return this.newCommerce;
      },
      set(val: boolean): void {
        this.$emit('update:newCommerce', val);
      },
    },
  },
  methods: {
    ...mapActions({
      saveCommerceKind: `commerceModule/commerceKind/${commerceKind.actions.SAVE_COMMERCE_KIND}`,
    }),
    cancelEditing(): void {
      this.syncedNewCommerceKind = false;
    },
    async saveNewCommerceKind(newCommerceKind: newCommerceKindType): Promise<void> {
      this.loading = true;
      await this.saveCommerceKind(newCommerceKind)
        .then(() => {
          this.clean = true;
        })
        .finally(() => {
          this.syncedNewCommerceKind = false;
          this.clean = false;
          this.loading = false;
        });
    },
  },
});

